import {
  CONFERENCE_RESET,
  CONFERENCE_SET,
  CONFERENCE_UPDATE,
  CONFERENCE_SET_CONSULT,
  UPDATE_CONFERENCE_TRANSFER_ENDPOINTS,
  DIAL_CONFERENCE_IN_PROGRESS,
  HISTORY_FILTER_CONFERENCE_COUNT,
  RESET_STATE,
  LOGOUT,
  STORE_LOGIN,
} from "../constants/action-types";
import { ConferenceState } from "../types/call.type";


const initialState: ConferenceState = {
  id: "",
  customer: null,
  self: null,
  queue: undefined,
  allowedTransferEndpoints: [],
  dialCallInProgress: false,
  isMerged:false,
  isUnderSupervision: false,
  beingBarged: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case CONFERENCE_SET:
      if (action.payload?.id) {
        return {
          ...state,
          ...action.payload,
          type: "conference",
        };
      }
      return {
        ...initialState,
      };

    case CONFERENCE_UPDATE:
      const connectedTime = action.payload?.self?.connectedTime
        ? new Date(action.payload.self.connectedTime).getTime()
        : state.self?.connectedTime || 0;

      const endTime = action.payload?.self?.endTime
        ? new Date(action.payload.self.endTime).getTime()
        : 0;

      return {
        ...state,
        ...action.payload,
        type: "conference",
        self: action.payload?.self ? {
          ...action.payload.self,
          connectedTime,
          endTime,
        } : state.self,
      };

    case CONFERENCE_SET_CONSULT:
      return {
        ...state,
        consultCall: action.consultCall,
      };

    case UPDATE_CONFERENCE_TRANSFER_ENDPOINTS:
      return {
        ...state,
        allowedTransferEndpoints: action.conference,
      };

    case DIAL_CONFERENCE_IN_PROGRESS:
      return {
        ...state,
        dialCallInProgress: action.dialCallInProgress,
      };

    case HISTORY_FILTER_CONFERENCE_COUNT:
      return {
        ...state,
        callCount: action.callCount,
      };

    case STORE_LOGIN:
      return {
        ...state,
        ...action.payload?.conference,
      };

    case LOGOUT:
    case CONFERENCE_RESET:
      return { ...initialState };
    case RESET_STATE:
      return {};
    default:
      return state;
  }
};
